export default __webpack_public_path__ + "static/editionen-final-0b197c20acf427f40fb7e92484c8e634.gif";